import React, { useState } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Select,
  MenuItem,
} from '@mui/material';
import CustomerSummaryCard from './CustomerSummaryCard';
import RevenueChecker from './RevenueChecker';
import { VM_Colors } from '../../Styles/VMStyles';

const months = [
  { name: "January", value: 1 },
  { name: "February", value: 2 },
  { name: "March", value: 3 },
  { name: "April", value: 4 },
  { name: "May", value: 5 },
  { name: "June", value: 6 },
  { name: "July", value: 7 },
  { name: "August", value: 8 },
  { name: "September", value: 9 },
  { name: "October", value: 10 },
  { name: "November", value: 11 },
  { name: "December", value: 12 },
];

const currentYear = new Date().getFullYear();
const years = [currentYear - 1, currentYear, currentYear + 1];

function VMReports() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  return (
    <Box sx={{ width: '100%',}}>
      {/* Header Row */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: isSmall ? 'column' : 'row',
          mb: 2,
        }}
      >
        <Typography variant='h3' sx={{ mb: isSmall ? 2 : 0 }}>
          Reports
        </Typography>

        <Box display="flex">
          <Select
            value={selectedMonth}
            onChange={handleMonthChange}
            size="small"
            sx={{ minWidth: 120 }}
            displayEmpty
          >
            <MenuItem value="" disabled>  -- Select --   </MenuItem>
            {months.map((month) => (
              <MenuItem key={month.value} value={month.value}>
                {month.name}
              </MenuItem>
            ))}
          </Select>
          <Select
            value={selectedYear}
            onChange={handleYearChange}
            size="small"
            sx={{ minWidth: 100, ml: 2 }}
            displayEmpty
          >
            <MenuItem value="" disabled>  -- Select --   </MenuItem>
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      {/* Report Cards Row */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isSmall ? 'column' : 'row',
          gap: 2,
          width: '100%',
          backgroundColor: VM_Colors.white1,
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <CustomerSummaryCard
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
          />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <RevenueChecker 
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default VMReports;
